import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Common/Footer';
import { useTheme } from '../DataStore/ThemeContext';
import SuccessDialog from './Common/SuccessDialog';
import GlobalSystemModal from './GlobalSystemModal';

const PageContainer = (props) => {
  const { settingsOpen, closeSettings, settingTitle, settingCode, settingData, clearSweetDialogInfo, sweetDialogInfo, settingButtonLabel, toggleSidebar, isSidebarOpen, toggleMobileHeader, isMobileHeaderOpen, showSettingButtons } = useTheme();

  const [isWebView, setIsWebView] = useState(true); // Assume web view initially
  

  // Update `isWebView` based on window width
  useEffect(() => {
    const handleResize = () => {
      setIsWebView(window.innerWidth > 768); // Web view if width > 768px
    };

    handleResize(); // Check on initial render
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  // Determine dynamic class
  const containerClass = [
    'app-container',
    'app-theme-white',
    'body-tabs-shadow',
    'fixed-header',
    'fixed-sidebar',
    isSidebarOpen ? '' : 'closed-sidebar',
    !isWebView && isSidebarOpen ? 'sidebar-mobile-open' : '',
    !isWebView && !isSidebarOpen ? 'closed-sidebar-mobile' : ''
  ]
    .filter(Boolean) // Remove empty strings
    .join(' ');

  return (
    <>
    <div className={containerClass}>
      <Header
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        mobileHeaderIsOpen={isMobileHeaderOpen}
        toggleMobileHeader={toggleMobileHeader}
      />
      <div className="app-main">
        <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div className="app-main__outer">
          {props.children}
          <Footer />
        </div>
      </div>
      <GlobalSystemModal
        settingsOpen={settingsOpen}
        closeSettings={closeSettings}
        settingTitle={settingTitle}
        settingCode={settingCode}
        settingData={settingData}
        buttonLabel={settingButtonLabel}
        showButtons={showSettingButtons}
      />
      {/* Backdrop */}
      {settingsOpen && <div className="modal-backdrop fade show" style={{backgroundColor: 'rgba(16,19,41,.35)'}}></div>}

    </div>
    <SuccessDialog
        show={sweetDialogInfo? true : false}
        onClose={clearSweetDialogInfo}
        message={sweetDialogInfo?.title}
        details={sweetDialogInfo?.subtitle}
  />
    </>
  );
};

export default PageContainer;
